<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    @close="handleClose"
    :modal="false"
    width="864px">

    <div class="content">
      <!--left panel-->
      <div class="infoPanel">
        <div class="panel-div">
          <h3 class="panel-title">客户详情：</h3>
          <div class="info">
            <span class="info-span" :title="customerNameField">{{customerNameField}}：</span>
            <span class="info-span" :title="customerName">{{customerName}}</span>
          </div>
          <div class="info">
            <span class="info-span" :title="customerPhoneField">{{customerPhoneField}}：</span>
            <span class="info-span" :title="customerPhone">{{customerPhone}}</span>
          </div>
          <div class="info">
            <label class="info-label">流&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;程：</label>
            <span class="info-span" :title="flow">{{flow}}</span>
          </div>
          <div class="info">
            <label class="info-label">通话时间：</label>
            <span class="info-span" :title="startTime">{{startTime}}</span>
          </div>
          <div class="info">
            <label class="info-label">通话状态：</label>
            <span class="info-span" :title="callStatus">{{callStatus}}</span>
          </div>
          <Row style="padding-top: 15px">
            <Col span="10" offset="1">
              <Card :padding="10" >
                <p slot="title" >{{callTime}}</p>
                <p>通话时长</p>
              </Card>
            </Col>
            <Col span="10" offset="1">
              <Card :padding="10">
                <p slot="title">{{callCount}}</p>
                <p>通话轮次</p>
              </Card>
            </Col>
          </Row>
        </div>
        <!--待开放-->
        <Divider></Divider>
        <div class="panel-div">
          <!--待开放-->
          <!--<div class="info">
            <label class="info-label2">客户意向：</label>
            <span class="info-span" :title="customerThink">{{customerThink}}</span>
          </div>-->
          <div class="info">
            <label class="info-label2">客户标签：</label>
            <span class="info-span" :title="customerTip">{{customerTip}}</span>
          </div>
          <div class="info">
            <label class="info-label2">关&nbsp;&nbsp;注&nbsp;&nbsp;点：</label>
            <span class="info-span" :title="customerFocus">{{customerFocus}}</span>
          </div>
        </div>
      </div>
      <!--content panel-->
      <div class="chatPage" :style="setStyle">
        <div class="taleBox" ref="scrollNode">
          <chatList
            :list="chatList"
            @click="bindEvent"
            @loadHistory="loadHistoryHandler"
            :config="chatListConfig"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import ChatList from "./chat/chatList";
  export default {
    name: "AICallDetail",
    components: {ChatList},
    props: ['callUuid', 'showCallDetailPop'],
    data(){
      return {
        dialogVisible:false,
        title:'AI通话详细',
        customerName:'',
        customerPhone:'',
        flow:'',
        startTime:'',
        callStatus:'',
        callTime:'',
        callCount:'',
        customerThink:'',
        customerTip:'',
        customerFocus:'',
        chatList:[],
        height:500,
        width:620,
        customerNameField:'',
        customerPhoneField:'',
      }
    },
    methods:{
      initSearch(callUuid) {
        let param = {callId: callUuid}
        let that = this
        this.$http.post('AI/CallLog/queryAICallDetails',param).then(res=>{
          let response = res.data
          if (response.flag !== '666') {
            if (response.flag != '666') {
              that.$alert(response.msg,'提示',{
                confirmButtonText: '确定'
              })
              return false
            }
          }
          that.customerName = response.obj.customerName
          that.customerPhone = response.obj.customerPhone
          that.flow = response.obj.flow
          that.startTime = response.obj.startTime
          that.callStatus = response.obj.callState
          that.callTime = response.obj.allTime
          that.callCount = response.obj.count
          that.customerThink = ''
          that.customerTip = response.obj.customerTip
          that.customerFocus = response.obj.focus
          that.chatList = response.obj.chatList
        })
      },
      getFields: function(){
          let that=this;
          let param={
            moduleId: "1",
            pageNum:0,
            pageSize:0
          };
          this.$http.post("custom/fields.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            let fields = res.data.obj.list.content;
            that.customerNameField = fields.find(item => item.customColName == 'customerName').customName;
            that.customerPhoneField = fields.find(item => item.customColName == 'telephoneOne').customName;
          });
        },
      reset() {
        let that = this
        that.customerName = ''
        that.customerPhone = ''
        that.flow = ''
        that.startTime = ''
        that.callStatus = ''
        that.callTime = ''
        that.callCount = ''
        that.customerThink = ''
        that.customerTip = ''
        that.customerFocus = ''
        that.chatList = []
      },
      handleClose() {
        this.reset()
        this.$emit('closeCallDetail',true)
      },
      bindEvent(play) {
        this.$emit('clickTalk',play)
      },
      loadHistoryHandler() {
        const { historyConfig:{callback=null}={}} = this.chatListConfig
        callback && callback()
      }
    },
    computed:{
      setStyle() {
        let height = this.height
        let width = this.width
        if (`${height}`.match(/\d$/)) {
          height += 'px'
        }
        if (`${width}`.match(/\d$/)) {
          width += 'px'
        }
        const style = { height, width}
        return style
      },
      chatListConfig(){
        const {width,talkHeight:height,scrollToButton,scrollType,config:{historyConfig={}}={}} = this
        return { width,height,scrollToButton,scrollType,historyConfig}
      }
    },
    watch:{
      showCallDetailPop() {
        this.dialogVisible = this.showCallDetailPop
        if (this.showCallDetailPop) {
          this.getFields();
          this.initSearch(this.callUuid)
        }
      }
    }
  }
</script>

<style scoped lang="css">
.chatPage{
  position: relative;
  background: #fff;
  overflow: hidden;
  border: 1px solid #CCCCCC;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.12), 0 0 6px rgba(0,0,0,0.04);
}
.content{
  display: flex;
}
  .taleBox {
    height: 100%;
    min-height: 100px;
    overflow: hidden;
  }
  .infoPanel{
    position: relative;
    background: #B3C0D1;
    overflow: hidden;
    border: 1px solid #CCCCCC;
    border-radius: 5px;
    width: 200px;
    height: 500px;
    margin-right: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.12), 0 0 6px rgba(0,0,0,0.04);
  }
  .panel-div{
    width: 200px;
    height: calc(100% / 2 + 20px);
  }
  .panel-title{
    margin: 5px;
    width: calc(100% / 2 - 10px);
  }
  .info{
    margin: 5px 10px;
    display: flex;
  }
  .info-label{
    display: inline-block;
    float: left;
  }
.info-label2{
  width: 70px;
  display: inline-block;
  float: left;
  font-weight: bold;
}
  .info-span {
    max-width: 100px;
    display:block;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    -o-text-overflow:ellipsis;
    -icab-text-overflow:ellipsis;
    -khtml-text-overflow:ellipsis;
    -moz-text-overflow: ellipsis;
    -webkit-text-overflow:ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/aiManager/AICallDetail.vue